import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "form-label small mb-1" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-label small mb-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_toggler = _resolveComponent("toggler")!
  const _component_list_filler = _resolveComponent("list-filler")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, [
        _createVNode(_component_localized_text, {
          localizedKey: "Usa spunte",
          text: "Usa spunte"
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_toggler, {
          modelValue: _ctx.localValue.useChecks,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.useChecks) = $event))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", _hoisted_4, [
        _createVNode(_component_localized_text, {
          localizedKey: "Contenuto",
          text: "Contenuto"
        })
      ]),
      _createVNode(_component_list_filler, {
        modelValue: _ctx.localValue.points,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.points) = $event))
      }, null, 8, ["modelValue"])
    ])
  ], 64))
}